import Rails from "@rails/ujs";

export default ({
  transferBookingResourceSkuId,
  externalPositionId,
  associationType,
  transferDirection,
  externalPositionFlightId,
  success,
  error,
}) => {
  Rails.ajax({
    type: "POST",
    dataType: "json",
    url: `/api/external_positions/update_associations`,
    beforeSend: (xhr, options) => {
      xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
      // eslint-disable-next-line no-param-reassign
      options.data = JSON.stringify({
        transfer_booking_resource_sku_id: transferBookingResourceSkuId,
        external_position_id: externalPositionId,
        association_type: associationType,
        transfer_direction: transferDirection,
        external_position_flight_id: externalPositionFlightId,
      });

      return true;
    },
    success,
    error,
  });
};
